import {createSelector} from 'reselect';

export const profileCouponsSelector = props => props.profileCoupons.coupons;
export const userWalletSelector = props => props.profileCoupons.couponWallet;

export const getUnapprovedCoupons = createSelector(
	profileCouponsSelector,
	coupons => coupons && coupons.filter(coupon => coupon.status === 'PENDING_APPROVAL')
);

export const getApprovedCoupons = createSelector(
	profileCouponsSelector,
	coupons => coupons && coupons.filter(coupon => coupon.status === 'APPROVED')
);

export const getWalletCoupons = createSelector(
	userWalletSelector,
	coupons => coupons
);



// WEBPACK FOOTER //
// ./src/profile/coupons/profileCoupons.selector.js